export function handlePageCount(totalRecords: number, currentPageSize: number): number {
	return totalRecords <= currentPageSize
		? 1
		: (totalRecords / currentPageSize) % 1 === 0
		? totalRecords / currentPageSize
		: Math.floor(totalRecords / currentPageSize) + 1;
}
